import { render, staticRenderFns } from "./bo-select.vue?vue&type=template&id=2e80b55c"
import script from "./bo-select.vue?vue&type=script&lang=js"
export * from "./bo-select.vue?vue&type=script&lang=js"
import style0 from "./bo-select.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports